import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const QuoteViewContainer = styled.section`
  padding: 20px 0px;
`;

export const SectionContainer = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  font-family: Lato;
  font-style: normal;
  letter-spacing: 0;
  text-align: left;
`;

export const QuoteRightInfo = styled.div`
  display: flex;
  max-width: ${(props) => (props?.maxWidth ? props.maxWidth : "60%")};
`;
export const QuoteTitle = styled.h2`
  font-size: ${(props) => (props?.fontSize ? props.fontSize : "18px")};
  font-weight: ${(props) => (props?.fontWeight ? props.fontWeight : "700")};
  line-height: 1rem;
  color: #0a4986;
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "10px")};
`;

export const QuoteLeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const QuoteStatusBtn = styled.div`
  border-radius: 4px;
  color: #fff;
  font-size: 1rem;
  height: 2.5rem;
  line-height: 1rem;
  text-align: center;
  width: 7.75rem;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#FF5200"};
`;

export const QuoteMargin = styled.span`
  font-size: 1.25rem;
  font-weight: ${(props) => (props?.fontWeight ? props.fontWeight : "700")};
  line-height: 2rem;
  text-align: right;
  color: #767676;
`;

export const MarginDiv = styled.div`
  margin-top: 10px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-top: ${(props) => props.marginTop ?? "0px"};
`;

export const CommentContainer = styled.section`
  width: 100%;
  background: #ffffff;
  border: 1px solid #f6f6f6;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin-bottom: 2.125rem;
`;

export const CommentWraper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 0.25rem;
  justify-content: space-between;
`;

export const CommentPara = styled.div`
  font-family: Lato;
  font-size: 0.875rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: 0;
  text-align: left;
  color: #767676;
  margin: 0;
  padding: 0;
  min-height: 5rem;
  max-height: 8rem;
  overflow-y: auto;
  white-space: pre;
`;

export const QuoteServiceInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const HeaderWrapperTable = styled.div`
  background-color: #008395;
  display: table-column-group;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 4px 4px 0px 0px;
`;

export const Title = styled.h3`
  color: #fff !important;
  text-align: left;
  width: auto;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin: 0;
  margin-top: 3px;
  font-weight: ${(props) => props.fontWeight ?? "normal"};
`;

export const EnquiryIdHyphen = styled.span`
  text-decoration: ${(props) => props.decoration ?? "underline"};
  cursor: pointer;
  color: ${(props) => props.color ?? "#fff"};
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-weight: 700;
  font-size: ${(props) => props.fontSize ?? "#0a4986"};
  text-align: left;
`;

export const QuoteInfoAndConditionsInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 30px;
  border-radius: 4px;
  border-radius: 5px 5px 4px 4px;
  border: 1.5px solid #008395;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${(props) => props.padding ?? "20px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  background: rgba(0, 131, 149, 0.2);
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontstyle ?? "italic"};
  font-weight: 400;
  font-size: 14px;
  text-align: left;
`;

export const GridItem = styled.div`
  border-right: ${(props) =>
    props.borderRight ?? "2px solid rgba(10, 73, 134, 0.3)"};
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-bottom: 2px solid rgba(10, 73, 134, 0.3);
`;

export const HorizontalRow = styled.div`
  border: 1px solid rgba(10, 73, 134, 0.3);
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div {
    margin-right: 0.5rem;
  }
`;

export const ServiceInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props?.color ?? "#767676"};
  font-size: ${(props) => props?.fontSize ?? "14px"};
  font-weight: bold !important;
  padding: 15px;
`;

export const GridDateDiv = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontstyle ?? "italic"};
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  display: inline-flex;
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export const OuterDiv = styled.div`
  padding: 10px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => props.content ?? "space-between"};
  padding: ${(props) => props.padding ?? "0"};
`;

export const ErrorText = styled.span`
  width: 100%;
  color: gray;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  padding: 0;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const SectionContent = styled.section`
  width: 100%;
`;

export const ValidationMessage = styled.p`
  margin: ${(props) => props.margin ?? "16px 0;"};
  padding: 0;
  font-size: 14px;
  line-height: ${(props) => props.lineHeight ?? "40px;"};
  color: #767676;
  padding-top: ${(props) => props.paddingTop ?? "0;"};
`;

export const ValidationMessageSpan = styled.span`
  margin: ${(props) => props.margin ?? "16px 0;"};
  padding: 0;
  font-size: 14px;
  line-height: ${(props) => props.lineHeight ?? "40px;"};
  color: #767676;
  padding-top: ${(props) => props.paddingTop ?? "0;"};
`;

export const CenterContent = styled.div`
  text-align: center;
`;

export const ImgDiv = styled.div`
  align-content: center;
`;
